module.exports = __webpack_public_path__ + "img/browser-ie-logo.87423a68.webp";